import { AxiosError } from 'axios';
import dayjs from 'dayjs';
import { post } from '@/utils';
import { IRestrictObj } from './types';

// BE așteaptă { reason, durationMinutes } (0 = permanent). În UI ținem `until` ca timestamp absolut
// (0 = permanent), așa că îl convertim aici în minute față de momentul curent.
const toDurationMinutes = (until?: number): number => {
	if (!until || until <= 0) return 0;
	const mins = Math.round((until - dayjs().valueOf()) / 60000);
	// dacă data aleasă e deja trecută, trimitem minim 1 minut ca să nu devină „permanent".
	return mins > 0 ? mins : 1;
};

const toRestrictionPayload = (
	restrictObj: IRestrictObj
): { reason: string; durationMinutes: number } => ({
	reason: restrictObj.reason,
	durationMinutes: toDurationMinutes(restrictObj.until)
});

// BE poate răspunde cu orice status de succes 2xx (200–204).
const isOk = (status?: number): boolean =>
	typeof status === 'number' && status >= 200 && status <= 204;

async function patchMuteChat(
	userId: number | string,
	restrictObj: IRestrictObj
): Promise<{ messages: string[]; status: number } | number> {
	try {
		const res = await post(
			`api/users/${userId}/mute`,
			toRestrictionPayload(restrictObj)
		);
		const data = res?.data as unknown as { messages: string[] };
		return isOk(res?.status)
			? { messages: data?.messages, status: res?.data?.status }
			: 400;
	} catch (e) {
		const error = e as AxiosError;
		const data = error.response?.data as { error: string };
		throw new Error(data?.error || 'Nu ma reusit sa restrictionam utilizatorul.');
	}
}

async function patchBlock(
	userId: number | string,
	restrictObj: IRestrictObj
): Promise<string | number> {
	try {
		const res = await post(
			`api/users/${userId}/block`,
			toRestrictionPayload(restrictObj)
		);
		return isOk(res?.status) ? 200 : 400;
	} catch (e) {
		const error = e as AxiosError;
		const data = error.response?.data as { error: string };
		throw new Error(data?.error || 'Nu am reusit sa blocam utilizatorul.');
	}
}

async function patchBlockChat(
	userId: number | string,
	restrictObj: IRestrictObj
): Promise<{ messages: string[]; status: number } | number> {
	try {
		const res = await post(
			`api/users/${userId}/block`,
			toRestrictionPayload(restrictObj)
		);
		const data = res?.data as unknown as { messages: string[] };
		return isOk(res?.status)
			? { messages: data?.messages, status: res?.data?.status }
			: 400;
	} catch (e) {
		const error = e as AxiosError;
		const data = error.response?.data as { error: string };
		throw new Error(data?.error || 'Nu ma reusit sa blocam utilizatorul.');
	}
}

async function patchUnblock(userId: number | string): Promise<string | number> {
	try {
		const res = await post(`api/users/${userId}/unblock`);
		return isOk(res?.status) ? 200 : 400;
	} catch (e) {
		const error = e as AxiosError;
		const data = error.response?.data as { error: string };
		throw new Error(data?.error || 'Nu am reusit sa deblocam utilizatorul.');
	}
}

async function patchUnmute(userId: number | string): Promise<string | number> {
	try {
		const res = await post(`api/users/${userId}/unmute`);
		return isOk(res?.status) ? 200 : 400;
	} catch (e) {
		const error = e as AxiosError;
		const data = error.response?.data as { error: string };
		throw new Error(data?.error || 'Nu am reusit sa derestrictionam utilizatorul.');
	}
}

export { patchBlock, patchUnblock, patchUnmute, patchBlockChat, patchMuteChat };
